import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Costanti } from 'app/main/utils/costanti';
import { SessioneUtenteQuery } from 'app/main/utils/state';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, shareReplay, skip, startWith, switchMap } from 'rxjs/operators';
import { NppPermessi } from '../interfaces/npp-permessi.interface';

@Injectable({
  providedIn: 'root'
})
export class NppPermessiService {
  private BASEURL = Costanti.NPP_APIURL + 'npp/permessi';
  private permessi$?: Observable<NppPermessi>;
  private refreshPermessi$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private sessioneUtenteQuery: SessioneUtenteQuery
  ) {
    this.sessioneUtenteQuery.loggedInUserChange$.pipe(skip(1)).subscribe(() => this.reset());
  }

  reset() {
    this.refreshPermessi$.next();
  }

  getPermessi(): Observable<NppPermessi> {
    if (!this.permessi$) {
      this.permessi$ = this.refreshPermessi$.pipe(
        startWith(undefined),
        switchMap(() =>
          this.http.get(this.BASEURL).pipe(
            map((res: any) => (res && res.data ? res.data : {})),
            catchError(() => of({}))
          )
        ),
        shareReplay(1)
      );
    }

    return this.permessi$;
  }
}
